export const operations=[
    {
        uid:'1ac75355-ae02-4c0c-82d5-de47b3131190',
        name:'Importação',
        value: 'I',
        icon:'FaReply'
    },
    {
        uid:'70303c68-f44b-4902-b9e8-d94dfd42346b',
        name:'Exportação',
        value: 'E',
        icon: 'FaShare'
    }
];

export const freightTypes=[
    {
        uid:'ebb131a3-5825-41dd-b64b-c465d8ae64cd',
        name: 'FCL',
        value:'FCL',
        icon: 'FaBox'
    },
    {
        uid:'03b6c5ab-0457-4bdd-b8b0-b28bf152ca98',
        name: 'LCL',
        value:'LCL',
        icon: 'FaBoxes'
    },
    {
        uid:'5daebb7e-d79d-4b45-84ff-03a998ec7ec6',
        name: 'BREAKBULK',
        value:'BBK',
        icon: 'FaBoxes'
    },
];

export const modals = [
    {
        uid:'9f36b4b4-b8ce-48ab-aade-d1c2f0514d5e',
        name:'Marítimo',
        value:'M',
        icon: 'FaAnchor',
        isActive: true
    },
    {
        uid:'d00413c3-165d-4422-96f5-ea01a9efc2c1',
        name:'Aéreo',
        value:'A',
        icon: 'FaPlane',
        isActive: true

    },
    {
        uid:'86fd8663-358d-4e18-a0fb-a6ac1ac2bafc',
        name:'Rodoviário',
        value:'R',
        icon: 'FaTruckMoving',
        isActive: true

    },
]

export const currencies = [
    {
        uid: '93f36b88-d181-4d18-8ce5-23498fe7378b',
        name: 'Dólar',
        value:'USD'
    },
    {
        uid: '1e8cc81a-962d-4e40-b487-12d7c036322d',
        name: 'Euro',
        value:'EUR'
    },
];

export const quotationStatus = [
    {
        uid:'14dbc54d-595e-4e5e-aa57-94a85bc81b12',
        name: 'Em Cotação',
        value: 1
    },
    {
        uid:'ca53322b-f421-49e4-9634-bf9a0df0cb06',
        name: 'Cotação Realizada',
        value: 2
    },
    {
        uid:'26be99a4-faac-4518-a384-74ca62cd3109',
        name: 'Cotação Aprovada',
        value: 3
    },
    {
        uid:'a983a68f-be15-4663-a09d-b337c2fe5829',
        name: 'Cotação Reprovada',
        value: 4
    },
    {
        uid:'c83eb635-e0f1-491e-9dd9-0b8862750c94',
        name: 'Cotação Rejeitada',
        value: 5
    },
]

export const shipmentStatus = [
    {
        uid: 'db952a3b-3d38-4758-a1ad-6f9e60965700',
        name: 'Aguardando',
        value: 1
    },
    {
        uid: '5ee54552-108c-43e2-9380-9350dd381806',
        name: 'Em Transporte',
        value: 2
    },
    {
        uid: '1143d3fd-9c5a-45db-a45e-99ef42d9016d',
        name: 'Em Processo Aduaneiro',
        value: 3
    },
    {
        uid: '5d07e047-398c-49a6-a5d2-d4a029b6baa0',
        name: 'Entregue',
        value: 4
    },
    {
        uid: '8a855f03-4eca-4515-82fb-e2febbd55382',
        name: 'Finalizado',
        value: 5
    },
]

export const countries = [
    {
        uid:"21a543f1-15f1-471d-be51-0061da0c1830",
        code:"CAN",
        name: "Canadá", 
        image:"can.png", 
        translationKey: "",
        dialCode: "+1",
        isActive: true
    },
    {
        uid:"b41b8a38-f88a-4d99-a16e-ff55b4908da5",
        code:"ZAF",
        name: "África do Sul", 
        image:"zaf.png", 
        translationKey: "",
        dialCode: "+1",
        isActive: false
    },
    {
        uid:"9210fbec-28c7-43df-834b-a18b1a98d819",
        code:"BRA",
        name: "Brasil", 
        image:"bra.png", 
        translationKey: "",
        dialCode: "+1",
        isActive: true
    }
]

export const containerTypes = [
    {
        uid:"0b4d8aad-cc6c-428e-8eed-a15349a71479", 
        name: "Dry Box 20 PÉS", 
        description: "Dry Box 20 PÉS é utilizado para cargas secas que são produtos industrializados e não perecíveis", 
        image:"dry-20.png", 
        translationKey: "",
        lengthValue: "5,919 mm",
        heightValue: "2,380 mm",
        widthValue: "2,340 mm",
        cubicCapacity: "33.0",
        payloadCapacity: "22,100 kg",
        isActive: true
    },
    {
        uid:"4fe22270-e4ef-4f14-a178-6d7bd9e1cfc4", 
        name: "Dry Box 40 PÉS", 
        description: "Dry Box 40 PÉS é maior que o de 20 PÉS e portanto consegue transportar uma maior quantidade de produtos. Também é indicado para cargas secas", 
        image:"dry-40.png", 
        translationKey: "",
        lengthValue: "12,045 mm",
        heightValue: "2,379 mm",
        widthValue: "2,309 mm",
        cubicCapacity: "67,3 cmb",
        payloadCapacity: "27,396 kg",
        isActive: true

    },
    {
        uid:"a83fe22d-ee7f-4518-ab13-51b09f1e50c2", 
        name: "High Cube 40 PÉS", 
        description: "High Cube 40 PÉS possui espaço interno e externo maiores, é indicado para realizar o transporte de grandes quantidades de mercadorias e também é útil para o carregamento de projetos customizados, devido a sua altura e largura diferenciadas.", 
        image:"hc-40.png", 
        translationKey: "",
        lengthValue: "12,056 mm",
        heightValue: "2,684 mm",
        widthValue: "2,347 mm",
        cubicCapacity: "76.0 cmb",
        payloadCapacity: "29,600 kg",
        isActive: true

    },
]

export const documentTypes = [
    {
        uid:"08dce086-4606-4f9e-86b6-3c75b5d36dd9",
        name: "Cartão do CNPJ", 
        description: "Compromente de inscrição da empresa na Receita Federal.",
        translationKey:"",
        isActive: true
    },
    {
        uid:"a615d7e9-3ad1-4e89-93c0-ca58e282741f",
        name: "Contrato Social", 
        description: "Contrato Social e alterações registrados na Junta Comercial.",
        translationKey:"",
        isActive: true

    },
    {
        uid:"2f0006b2-5746-4abd-a044-35fb521b0654",
        name: "Invoice", 
        description: "Invoice enviada pelo fornecedor contendo os itens e valores comprados.",
        translationKey:"",
        isActive: true

    }
]

export const incoterms = [
    {
        uid:"6390eae0-ef17-4cfe-841f-1f0cd5b756c6",
        code:"CIF",
        name: "Custo, Seguro e Frete", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"b5be6cbe-a131-4904-ad6b-4c6a570da3e5",
        code:"FOB",
        name: "Livre a Bordo", 
        translationKey: "",
        isActive: true
    },
]

export const loadTypes = [
    {
        uid:"c284063e-018e-4178-95a8-2c8c79793efb", 
        code:"VES",
        name: "Vestuário", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"331e0dc6-0227-4240-8cae-8d4c5d1aa796", 
        code:"FOO",
        name: "Alimento Seco", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"e4dc022f-9ee6-4e6a-a6cc-8fc014b40e3e", 
        code:"DAN",
        name: "Perigoso", 
        translationKey: "",
        isActive: true
    },
]

export const locationTypes = [
    {
        uid:"3f669f5f-b546-483d-9c60-24b9ff9f343d",
        name: "Cidade", 
        icon:"FaBuilding", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"e8eb47da-431e-47a5-a25a-8d4cf25add02",
        name: "Aeroporto", 
        icon:"FaPlane", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"d784e83b-97da-49d5-a11d-8e9edbd0f017",
        name: "Porto", 
        icon:"FaAnchor", 
        translationKey: "",
        isActive: false
    },
]

export const locations = [
    {
        uid:"5099e33e-c306-47a0-bc5a-0424fd9a058b",
        code:"GRU",
        name: "Guarulhos",
        translationKey: "",
        locationType:{
            uid:"e8eb47da-431e-47a5-a25a-8d4cf25add02",
            name:"Aeroporto",
            icon: 'FaPlane'
        },
        country:{
            uid:"9210fbec-28c7-43df-834b-a18b1a98d819",
            name:"Brasil"
        },
        isActive: true
    },
    {
        uid:"b0cfed3b-0205-40ae-9c12-da5a5f93e366",
        code:"CNSHG",
        name: "Shanghai",
        translationKey: "",
        locationType:{
            uid:"d784e83b-97da-49d5-a11d-8e9edbd0f017",
            name:"Porto",
            icon:'FaAnchor'
        },
        country:{
            uid:"47d96a64-65cb-4512-bc04-9e19145cae16",
            name:"China"
        },
        isActive: true
    },
    {
        uid:"58b8482d-35b9-4ab0-96ab-75a9be984fbe",
        code:"BRSSZ",
        name: "Santos",
        translationKey: "",
        locationType:{
            uid:"d784e83b-97da-49d5-a11d-8e9edbd0f017",
            name:"Porto",
            icon: 'FaAnchor'
        },
        country:{
            uid:"9210fbec-28c7-43df-834b-a18b1a98d819",
            name:"Brasil"
        },
        isActive: true
    },
]

export const packageTypes = [
    {
        uid:"7ff3aa6f-4f4b-49e0-bc34-0431f4f049e6",
        name: "Pacote", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"572c6754-9aad-4a5f-af59-30d29a28ef4c",
        name: "Caixa", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"ae7da45c-76bc-4207-9be2-5047d754f75f",
        name: "Saco", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"69bd09d3-e349-4f68-bbc0-8e91bb747cb6",
        name: "Barril", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"8c48b18c-5d3b-44d5-b697-a10955ca4a46",
        name: "Case", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"0ac98e93-5c32-4d5f-8ebe-c7fdcbc931cb",
        name: "Palete", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"a4440ef4-1824-4489-a10b-cddd74337ff8",
        name: "Outro", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"0b681985-ad6f-42e6-841b-d44a4cb4d282",
        name: "Tambor", 
        translationKey: "",
        isActive: true
    },
    {
        uid:"441598d8-14e9-476b-9866-e9a81d15dddc",
        name: "Carton", 
        translationKey: "",
        isActive: true
    },
]

export const customers = [
    {
        uid:"fedc33d5-952a-45e3-a55b-043b7df59f2a", 
        document: "00.000.000/0001-00", 
        companyName: "ABC E-Commerce Comércio de Produtos Ltda", 
        commercialName:"ABC E-Commerce", 
        city: "São Paulo", 
        state: "SP", 
        isActive: true
    },
    {
        uid:"a7932e5e-2625-4cc1-ac59-c1ac9d44abf5", 
        document: "09.323.835/0001-57", 
        companyName: "Btwo Company Brasil Atacado E Distribuicao Ltda", 
        commercialName:"Btwocompany Brasil Distribuicao", 
        city: "Serra", 
        state: "ES", 
        isActive: true
    },
    {
        uid:"fda1b5ee-6829-48da-aedf-232b9f888de4", 
        document: "41.156.932/0001-05", 
        companyName: "I.b E-commerce Comercio De Artigos E Vestuarios Ltda", 
        commercialName:"",
        city: "Barueri", 
        state: "SP", 
        isActive: false
    },
    {
        uid:"baefd354-1f2f-4b8c-a12d-34e5e2fee1e1", 
        document: "40.178.084/0001-72", 
        companyName: "Blue Ocean E-commerce Ltda", 
        commercialName:"Blue Ocean", 
        city: "Uberlândia", 
        state: "MG", 
        isActive: true
    },
    {
        uid:"ec7ac2a7-d2d9-4be6-9414-d5cb71180f30", 
        document: "35.208.762/0001-62", 
        companyName: "Agro Atacado Distribuidora Veterinaria Ltda", 
        commercialName:"Agro Atacado", 
        city: "Franca", 
        state: "SP", 
        isActive: true
    },
]